import { Koi } from '@ksyos/koi';

export const afwijkingenSchema = Koi.object().keys({
    aangeboren_nystagmus: Koi.boolean().allow(null),
    amblyopie_od: Koi.boolean().allow(null),
    amblyopie_os: Koi.boolean().allow(null),
    anders_text: Koi.string().max(255).allow(null),
    cataract_od: Koi.boolean().allow(null),
    cataract_os: Koi.boolean().allow(null),
    drp_od: Koi.boolean().allow(null),
    drp_os: Koi.boolean().allow(null),
    glaucoom_od: Koi.boolean().allow(null),
    glaucoom_os: Koi.boolean().allow(null),
    md_droog_od: Koi.boolean().allow(null),
    md_droog_os: Koi.boolean().allow(null),
    md_nat_od: Koi.boolean().allow(null),
    md_nat_os: Koi.boolean().allow(null),
    pseudofaak_od: Koi.boolean().allow(null),
    pseudofaak_os: Koi.boolean().allow(null),
    verworven_nystagmus: Koi.boolean().allow(null),
});
